import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";
import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { DeliveryOrderForm } from "@/features/delivery-orders";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { CenteredLoading, useSnackbar } from "@/features/ui";

export const CreateDeliveryOrder = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      const { sellerId, ...payload } = formData;

      await apiOutletClient.post("delivery-orders", payload, {
        headers: {
          "Outlet-Id": sellerId,
        },
      });
      navigate(-1);
    } catch (error) {
      const errorMessage =
        getErrorMessage(error, "Gagal membuat pengiriman");
      showSnackbar(errorMessage);
    }
  };

  if (!outlet) {
    return <CenteredLoading />;
  }

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Pengiriman Penjualan"
      breadcrumbs={[
        { title: "Pengiriman Penjualan", path: "/sales/delivery-orders" },
        { title: "Buat" },
      ]}
    >
      <DeliveryOrderForm
        onSubmit={handleSubmit}
        defaultValues={{
          seller: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
